import React from 'react'
import { ConfigProvider } from 'antd'
import { DrawerStyles } from 'antd/es/drawer/DrawerPanel'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import AppRoutes from 'AppRoutes'
import reportWebVitals from 'reportWebVitals'
import { GlobalStyle } from './globalStyle'
import { store, persistor } from './redux/store'
import theme from './theme'
import Scan from '../src/flows/ScanWeb/HomeScreen/index'
import './index.css'
import StudioSetupScreen from '../src/flows/ScanWeb/StudioSetupScreen/index'

const router = createBrowserRouter([
  {
    path: '*',
    element: <AppRoutes />,
  },
  {
    path: '/scan/auth',
    element: <StudioSetupScreen />,
  },
  {
    path: '/scan/home',
    element: <Scan />,
  },
])

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <ConfigProvider
    theme={theme}
    // drawer={{
    //   styles: drawerStyles,
    // }}
  >
    <GlobalStyle />
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouterProvider router={router}></RouterProvider>
      </PersistGate>
    </Provider>
  </ConfigProvider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
